<template>
  <Menu v-slot="{ open }" as="div" class="relative inline-block">
    <slot name="activator" :isActive="isActive" :small="small" :open="open">
      <FilterMenuButton :isActive :small :open />
    </slot>
    <Transition mode="out-in" name="scale">
      <div
        v-if="open"
        class="absolute right-8 top-8 z-20 origin-top-right space-y-1 rounded-md bg-white p-2 capitalize shadow-md"
      >
        <FilterMenuItems v-model="model" :items :small>
          <template #default="{ item, index, depth }">
            <slot :item="item" :index="index" :depth="depth" />
          </template>
          <template #count="{ item, index, depth }">
            <slot name="count" :item="item" :index="index" :depth="depth" />
          </template>
        </FilterMenuItems>
      </div>
    </Transition>
  </Menu>
</template>

<script lang="ts" setup generic="T">
import type { AnyFilterItem, FilterMenuValue } from "./FilterMenuTypes";
import { traverseItems } from "~/components/filter/traverseItems";

interface Props {
  items: AnyFilterItem<T>[];
  small?: boolean;
  modelValue: FilterMenuValue<T>[];
  startSelected?: boolean;
}

type Emits = {
  "update:modelValue": [items: Props["modelValue"]];
};

const { small = false, startSelected = false, items } = defineProps<Props>();

defineEmits<Emits>();

const model = defineModel<Props["modelValue"]>({
  required: true,
});

const totalItems = computed(() => {
  let count = 0;
  traverseItems(items, ({ item }) => {
    if (!item.heading) {
      count++;
    }
  });
  return count;
});

const isActive = computed(() => model.value.length !== totalItems.value);

watchOnce(
  () => startSelected,
  (value) => {
    if (value) {
      traverseItems(items, ({ item }) => {
        if (!item.heading) {
          model.value.push(item);
        }
      });
    }
  },
  { immediate: true }
);
</script>
